// extracted by mini-css-extract-plugin
export default {"section-sets__header":"section-sets__header--20Ds8"};
    if(module.hot) {
      // 1747648180715
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  